import React from 'react'

import { Formik, Form } from 'formik';
import FormikFieldGroup from './shared/FormikFieldGroup'
import FormikPasswordField from './shared/FormikPasswordField'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'

import Button from '@material-ui/core/Button';
import classnames from 'classnames'
import { Typography } from '@material-ui/core';
import Link from '@material-ui/core/Link'

const styles = (theme) => ({
    padding2: {
        padding: theme.spacing(2)
    },
    padding3: {
        padding: theme.spacing(3)
    },
    playerContainer: {
        marginTop: theme.spacing(2)
    },
    marginTop3: {
        marginTop: theme.spacing(3)
    },
    marginTop8: {
        marginTop: theme.spacing(8)
    },
    marginTop5: {

        marginTop: theme.spacing(5)
    },
    marginTop2: {
        marginTop: theme.spacing(2)
    },
    marginBottom5: {
        marginBottom: theme.spacing(5)
    },
    button: {
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        letterSpacing: '1px',
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: 'transparent'
        }
    },
    buttonPay: {
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: theme.palette.primary.main
        }
    },
    buttonCustomDashed: {
        color: '#009BE1',
        background: 'white',
        fontWeight: 600,
        border: '2px dashed #009BE1'

    },
    marginBottom2: {
        marginBottom: theme.spacing(3)
    },
    marginBottom1: {
        marginBottom: theme.spacing(1)
    },
    bold: {
        fontWeight: '600'
    },
    muted: {
        color: theme.palette.text.disabled
    },
    bgTransparent: {
        backgroundColor: 'transparent'
    },
    smallText: {
        fontSize: theme.spacing(1.75)
    },
    center: {
        textAlign: 'center'
    },
    subText: {
        fontWeight: 500,
        paddingLeft: theme.spacing(2)
    },
    header: {
        marginBottom: theme.spacing(3)

    },
    link: {
        cursor: 'pointer',
        color: theme.palette.primary.main + ' !important'
    },
    note: {
        color: 'grey',
        fontWeight: 600
    }

});



const LoginComponent = ({ classes, loginFn, resetFn, createNewAcctFn, prefilledEmail }) => {
    const emailLocked = Boolean(prefilledEmail)
    const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

    const handleRegister = (values, {
        setFieldError
    }) => {
        loginFn(values)

    }


    const validate = values => {
        const errors = {}

        if (!values.email) {
            errors.email = 'Email is required'
        } else if (!EMAIL_REGEX.test(values.email)) {
            errors.email = 'Invalid email address'
        }

        if (!values.password) {
            errors.password = 'Password is required'
        }

        return errors
    }

    return <div>
        <Formik
            initialValues={{
                email: prefilledEmail || '',
                password: '',
            }}
            enableReinitialize={true}
            onSubmit={handleRegister}
            validate={validate}
        >
            <Form autoComplete="off">
                <Paper className={classnames(classes.marginTop5, classes.marginBottom5, classes.padding2, classes.bgTransparent)}>
                    <Grid container item justify="center" className={classes.header}>
                        <Typography variant="h5">Login</Typography>

                    </Grid>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12}> Email Address</Grid>

                        <Grid item xs>
                            <Paper><FormikFieldGroup
                                label='Email'
                                name='email'
                                type='text'
                                placeholder='Please enter email'
                                elevation={2}
                                padding={12}
                                disabled={emailLocked}
                            /></Paper></Grid>
                    </Grid>

                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12}> Password</Grid>
                        <Grid item xs>

                            <Paper><FormikPasswordField label={'password'} placeholder="Please enter password" /></Paper>

                            <Grid container item xs justify="flex-end">
                                <Link component="a"
                                    variant="body2"
                                    underline="none"
                                    className={classes.link}
                                    onClick={resetFn}>Forgot Password ?</Link></Grid>
                        </Grid>


                    </Grid>
                    


                    <Grid container className={classes.marginTop2} justify="center" direction="column">
                        <Grid item xs>
                            <Button fullWidth={true} type="submit" variant="contained" size="large" name="MakePaymentBtn" color="primary" className={classes.buttonPay} >
                                Login
                            </Button>
                        </Grid>
                        
                    </Grid>
                    <Grid
                        container
                        direction="column"
                        className={classnames(classes.marginTop8, classes.note)}
                        justifyContent="center"
                        alignItems="center"
                        spacing={1}
                        >
                        <Grid item>
                            <Typography variant="body1">
                            Please log in using the email address associated with your account.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="body1">
                            If you don’t remember your password, please use the “Forgot Password” option to reset it.
                            </Typography>
                        </Grid>
                        </Grid>

                </Paper>

            </Form>
        </Formik>
    </div >

}


export default withStyles(styles)(LoginComponent)